import router from '@/router/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import { getOrganizeType } from '@/utils/cookies'

NProgress.configure({ showSpinner: false })

const whiteList = [
  '/login',
  '/404',
  // 群体报告下载页
  '/teachingProtection/motion/report/download',
  '/physicalAnalysis',
  '/show'
]

router.beforeEach(async(to: Route, _: Route, next: any) => {
  // Start progress bar
  if (to.path !== '/physicalAnalysis') {
    NProgress.start()
  }
  // Determine whether the user has logged in
  if (UserModule.token && getOrganizeType()) {
    // console.log('有token')
    if (to.path === '/login') {
      // If is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // Check whether the user has obtained his permission roles
      if (!UserModule.name) {
        try {
          // Get user info, including roles
          const organizeType = getOrganizeType()
          if (organizeType === 101) {
            await UserModule.GetUserInfo()
            const codes = UserModule.accesses.map((item:any) => parseInt(item.code))
            // console.log(codes)
            await PermissionModule.GenerateRoutes(codes)
            router.addRoutes(PermissionModule.addRouters)
          } else if (organizeType === 102) {
            await UserModule.GetOrganizeUserInfo()
            const codes = UserModule.accesses.map((item:any) => parseInt(item.code))
            // console.log(codes)
            await PermissionModule.GenerateRoutes(codes)
            router.addRoutes(PermissionModule.addRouters)
          }
          // await UserModule.getUnhandlerList()
          // Set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
          // console.log(222)
        } catch (err) {
          console.error(err)
          // Message.error(err || 'Has Error')
          // Remove token and redirect to login page
          // UserModule.ResetToken()
          // next(`/login?redirect=${to.path}`)
          NProgress.done()
          throw Error(err)
        }
      } else {
        // console.log('进入')
        next()
      }
    }
  } else {
    // console.log('无token')
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)

      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done()

  // set page title
  // document.title = to.meta.title
})
